export default {
    name: 'theme_module',
    state: {
        currentTheme: localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    },
    getters: {
        getCurrentTheme: (state) => state.currentTheme
    },
    mutations: {
        setTheme: (state, theme) => {
            state.currentTheme = theme;
            document.documentElement.setAttribute('data-theme', theme);
            localStorage.setItem('theme', theme);
        }
    },
    actions: {
        initializeTheme({ commit }) {
            const savedTheme = localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
            commit('setTheme', savedTheme);
        },
        toggleTheme({ commit, state }) {
            const newTheme = state.currentTheme === 'light' ? 'dark' : 'light';
            commit('setTheme', newTheme);
        }
    }
} 